import { render, staticRenderFns } from "./BranchGlobalSettingsHub.vue?vue&type=template&id=1e5ab185"
import script from "./BranchGlobalSettingsHub.vue?vue&type=script&lang=js"
export * from "./BranchGlobalSettingsHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports